export enum  DeliveryNoteTabsEnum {
  PRODUCTS = 'products',
  DELIVERY_INFORMATION = 'delivery-information',
  PREFERENCES = 'preferences'
}
